import React from 'react';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { openCreateAccountModal } from '../StaticBuilderActions';

class FinishLaterButton extends React.PureComponent {
  constructor(props) {
    super(props);

    this.finishLaterCtaOnClick = this.finishLaterCtaOnClick.bind(this);
  }

  finishLaterCtaOnClick() {
    window._track('Finish Later | Variation 1', `${window.CurrentDocumentInfo.type} | Static Builder`);
    this.props.openCreateAccountModal();
  }

  render() {
    return (
      <button
        className="static-builder-finish-later-cta-button"
        onClick={this.finishLaterCtaOnClick}
      >
        Finish Later
      </button>
    );
  }
}

FinishLaterButton.propTypes = {
  openCreateAccountModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    openCreateAccountModal,
  }, dispatch)
);

export default ReactRedux.connect(
  null,
  mapDispatchToProps,
)(FinishLaterButton);



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/FinishLaterButton/index.jsx